import React from "react";
import styled from "styled-components";
import AdvancementLine from "./AdvancementLine";

const Advancement = ({advancementType, advancement, target}) => {


    return (
        <Container className={'advancement'}>
            {advancementType === "percentage" ?
                <>
                    <AdvancementLine
                        advancement={advancement}
                        target={target}
                        advancementType={advancementType}
                    />
                    <p> {target} % </p>
                </>

                :
                <>
                    <AdvancementLine
                        advancement={advancement}
                        target={target}
                        advancementType={advancementType}
                    />
                    <p> {target} </p>
                </>
            }
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  padding: 0 1em;
  align-items: center;
  border: 1px solid rgba(166, 172, 181, 0.6);
  border-radius: 10px;

  p {
    font-size: 75%;
  }

  div {
    width: 100%;
  }

  #linear-container-okr {
    display: flex;
    height: 30%;

    p {
      align-self: center;
      width: 15%;
    }
  }

  .advancement-div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    height: 100%;

    p {
      display: none;
    }

    .progress-container {
      height: 100%;
      background: #ece8e8;
      border-radius: 30px;
      width: 70%;
    }
  }

  p:last-child {
    padding: 0 0.2em;
    background-color: rgba(51, 148, 246, 0.6);
    width: 30%;
    text-align: center;
    border-radius: 10px;
    color: #FAFAFA;
  }

  @media (min-width: 900px) {
    #linear-container-okr {
      p {
        width: 25%;
      }
    }
  }
`

export default Advancement;